import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataService } from '../../../../services/data.service';
import { DiagramInfo } from '../../models/diagram-info';
import { StdInputData } from '../../models/std-input-data';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { Router } from '@angular/router';
import { MeasurementService } from 'src/app/services/measurement.service';
import { UnitType } from 'src/app/models/enums/unit-type.enum';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { TighteningMethod } from '../../enums/tightening-method.enum';

@Component({
    selector: 'app-custom-flange-input',
    templateUrl: './custom-flange-input.component.html',
    styleUrls: ['./custom-flange-input.component.scss'],
})
export class CustomFlangeInputComponent implements OnInit {
    @Input() isRedirect: boolean;
    @Output() returnData: EventEmitter<StdInputData> = new EventEmitter();
    @Output() diagram: EventEmitter<DiagramInfo> = new EventEmitter();
    @Input() calculationType: any; // require when pipespec calc

    tooltip_position = 'above';
    isCustom: boolean = true;
    isStandardFlange: boolean = false;
    isRTJ: boolean;
    doGasketReset: boolean = false;
    flangeTypeId: string;
    flangeFacingTypeId: string;
    gasketTypeId: string;
    boltDimensionId: string;
    boltType: string;
    customStandardNameDefault: string;
    customPipeSizeDefault: string;
    gasketId: string;
    boltMaterialId: string;
    flangeMaterialId: string;
    customPipeScheduleDefault: string;
    washerThicknessDefault: number = 0;
    isAddnlOverideDefault: boolean = false;
    addnlThicknessDefault: string = '0.00 mm';
    addnlOverideValueDefault: string = '0.00 mm';
    tighteningSpecification: string = 'Informate Recommended';
    tighteningSpecOverideDefault: string;
    nutDimensionId: string;
    threadTypeDefault: string;
    boltQuantityDefault: number;
    minimumBoltDiameterDefault: string;
    recommendedGasketStressDefault: string;
    minimumGasketStressDefault: string;
    maximumGasketStressDefault: string;
    yDefault: string;
    mDefault: string;
    pAdditionalDefault: number = 0;
    customInputFormGroup: UntypedFormGroup;
    customInputData: StdInputData;
    tighteningMethod: TighteningMethod;
    boltMaterialAliasId:string='';
    flangeMaterialAliasId1:string='';
    flangeMaterialAliasId2:string='';
    gasketAliasId:string='';
    constructor(
        private fb: UntypedFormBuilder,
        private dataSvc: DataService,
        private globalEmittersService: GlobalEmittersService,
        private meaService: MeasurementService,
        public router: Router,
        public idmsSharedService: IdmsSharedService
    ) {}

    ngOnInit(): void {
        this.customInputData = new StdInputData();
        this.loadFormGroup();
        this.customInputFormGroup = this.fb.group({
            customStandardName: [this.customStandardNameDefault],
            customPipeSize: [this.customPipeSizeDefault],
            flangeType: [this.flangeTypeId, Validators.required],
            flangeFacingType: [this.flangeFacingTypeId, Validators.required],

            gasket: [this.gasketId, Validators.required],
            gasketType: [this.gasketTypeId, Validators.required],
            boltMaterial: [this.boltMaterialId],
            flangeMaterial: [this.flangeMaterialId, Validators.required],
            boltType: [this.boltType, Validators.required],
            threadType: [this.threadTypeDefault, Validators.required],
            boltSize: [this.boltDimensionId, Validators.required],
            boltQuantity: [
                this.boltQuantityDefault,
                { validators: [Validators.required, Validators.min(1), Validators.pattern(/^-?(0|[1-9]\d*)?$/)], updateOn: 'blur' },
            ],
            isRedAreaBoltSelected: [false],
            redAreaBolt: [this.minimumBoltDiameterDefault, { updateOn: 'blur' }],
            nutStandard: [this.nutDimensionId, Validators.required],

            customPipeSchedule: [this.customPipeScheduleDefault, { updateOn: 'blur' }],
            washer: [this.washerThicknessDefault],
            isAddnlOveride: [this.isAddnlOverideDefault],
            addnlThickness: [this.addnlThicknessDefault],
            addnlOverideValue: [this.addnlOverideValueDefault, { updateOn: 'blur' }],

            tighteningSpecification: [this.tighteningSpecification, Validators.required],
            tighteningSpecOveride: [this.tighteningSpecOverideDefault, { updateOn: 'blur' }],
            isRecGasketStress: [false], //checkBox for recGasketStress
            recGasketStress: [this.recommendedGasketStressDefault, { updateOn: 'blur' }],
            isMinGasketStress: [false], //checkBox for minGasketStress
            minGasketStress: [this.minimumGasketStressDefault, { updateOn: 'blur' }],
            isMaxGasketStress: [false], //checkBox for maxGasketStress
            maxGasketStress: [this.maximumGasketStressDefault, { updateOn: 'blur' }],
            isy: [false], //checkBox for y
            y: [this.yDefault, { updateOn: 'blur' }],
            ism: [false], //checkBox for m
            m: [this.mDefault, Validators.pattern(/^(\d*\.)?\d+$/)],
            ispAdditional: [false],
            pAdditional: [this.pAdditionalDefault],

            isRTJ: [false],
            flangeDiagramId: [''],
            flangeFacingDiagramId: [''],
            gasketDiagramId: [''],
            boltMaterialAliasId: [''],
            flangeMaterialAliasId1: [''],
            flangeMaterialAliasId2: [''],
            gasketAliasId: [''],
        });

        this.globalEmittersService.customInputForm.next(this.customInputFormGroup);
        this.customInputFormGroup.get('flangeType').valueChanges.subscribe((value) => [(this.flangeTypeId = value)]);

        this.customInputFormGroup.get('flangeFacingType').valueChanges.subscribe((value) => [(this.flangeFacingTypeId = value), this.setPrestine()]);

        this.customInputFormGroup.get('isRTJ').valueChanges.subscribe((value) => (this.isRTJ = value));

        this.customInputFormGroup.get('gasket').valueChanges.subscribe(() => (this.doGasketReset = false));

        this.customInputFormGroup.get('gasketType').valueChanges.subscribe((value) => (this.gasketTypeId = value));

        this.customInputFormGroup.get('boltType').valueChanges.subscribe((value) => [(this.boltType = value)]);

        this.customInputFormGroup.get('boltSize').valueChanges.subscribe((value) => [(this.boltDimensionId = value)]);

        //Diagrams
        this.customInputFormGroup.get('flangeDiagramId').valueChanges.subscribe((value) => this.emitDiagramEvent('Flange', value));
        this.customInputFormGroup.get('flangeFacingDiagramId').valueChanges.subscribe((value) => this.emitDiagramEvent('Flange Facing', value));
        this.customInputFormGroup.get('gasketDiagramId').valueChanges.subscribe((value) => this.emitDiagramEvent('Gasket', value));
        this.customInputFormGroup.get('boltQuantity').valueChanges.subscribe((value) => this.emitDiagramEvent('Torque Sequence', null, value));
        this.customInputFormGroup.get('ispAdditional').valueChanges.subscribe((value) => {
            if (value) {
                this.customInputFormGroup.get('pAdditional').setValidators([Validators.min(1), Validators.max(2)]);
                this.customInputFormGroup.get('pAdditional').setValue(0);
            } else {
                this.customInputFormGroup.get('pAdditional').clearValidators();
                this.customInputFormGroup.get('pAdditional')?.updateValueAndValidity();
            }
        });

        if (this.idmsSharedService.enableConfirmWithRouter(2) == true) {
            // Subscribe to valueChanges and emit the form when it changes
            this.customInputFormGroup.valueChanges.subscribe(() => {
                this.btnCustomInputConfirmClicked();
            });
        }

        this.globalEmittersService.tighteningProcedureForm.subscribe((form: UntypedFormGroup) => {
            if (form) {
                form.get('calcMethod').valueChanges.subscribe((methodType: string) => {
                    this.tighteningMethod = methodType.toLowerCase() == 'tension' ? TighteningMethod.Tension : TighteningMethod.Torque;
                });
            }
        });
    }

    loadFormGroup() {
        if (this.isRedirect && this.dataSvc.calculationData != null) {
            this.customStandardNameDefault = this.dataSvc.calculationData.input.calculationOverrides.standard;
            this.customPipeSizeDefault = this.dataSvc.calculationData.input.calculationOverrides.pipeSize;
            this.flangeTypeId = this.dataSvc.calculationData.input.recordId.flangeTypeId1;
            this.flangeFacingTypeId = this.dataSvc.calculationData.input.recordId.flangeFacingTypeId;
            this.flangeMaterialId = this.dataSvc.calculationData.input.recordId.flangeMaterialId1;
            this.boltMaterialId = this.dataSvc.calculationData.input.recordId.boltMaterialId;
            this.gasketId = this.dataSvc.calculationData.input.recordId.gasketId;
            this.globalEmittersService.selectedGasketId.next(this.gasketId);
            this.boltType = this.dataSvc.calculationData.input.others.boltType == 1 ? 'Imperial' : 'Metric';

            this.threadTypeDefault = this.dataSvc.calculationData.input.others.threadType;
            this.boltDimensionId = this.dataSvc.calculationData.input.recordId.boltDimensionId;
            this.nutDimensionId = this.dataSvc.calculationData.input.recordId.nutDimensionId;
            this.boltQuantityDefault = this.dataSvc.calculationData.input.others.boltQuantity;

            this.minimumBoltDiameterDefault = this.meaService.format(
                this.dataSvc.calculationData.input.calculationOverrides?.minimumBoltDiameter,
                UnitType.DefaultLengthUnit,
                3
            );
            this.recommendedGasketStressDefault = this.meaService.format(
                this.dataSvc.calculationData.input.calculationOverrides?.recommendedGasketStress,
                UnitType.DefaultStressUnit,
                2
            );
            this.minimumGasketStressDefault = this.meaService.format(
                this.dataSvc.calculationData.input.calculationOverrides?.minimumGasketStress,
                UnitType.DefaultStressUnit,
                2
            );
            this.maximumGasketStressDefault = this.meaService.format(
                this.dataSvc.calculationData.input.calculationOverrides.maximumGasketStress,
                UnitType.DefaultStressUnit,
                2
            );
            this.yDefault = this.meaService.format(this.dataSvc.calculationData.input.calculationOverrides?.y, UnitType.DefaultStressUnit, 2);
            this.mDefault = this.dataSvc.calculationData.input.calculationOverrides.m;

            this.customPipeScheduleDefault = this.meaService.format(
                this.dataSvc.calculationData.input.calculationOverrides.pipeSchedule,
                UnitType.DefaultLengthUnit,
                3
            );

            this.washerThicknessDefault = this.dataSvc.calculationData.input.others.washerThickness as unknown as number;

            if (this.dataSvc.calculationData.input.recordId.additionalThicknessId) {
                this.isAddnlOverideDefault = false;
                this.addnlThicknessDefault = this.dataSvc.calculationData.input.recordId.additionalThicknessId;
            } else if (this.dataSvc.calculationData.input.calculationOverrides.additionalThickness === '0.00 mm') {
                this.isAddnlOverideDefault = false;
                this.addnlThicknessDefault = '0.00 mm';
            } else if (this.dataSvc.calculationData.input.calculationOverrides.additionalThickness) {
                this.isAddnlOverideDefault = true;
                this.addnlOverideValueDefault = this.dataSvc.calculationData.input.calculationOverrides.additionalThickness;
            }
            this.tighteningSpecification = this.dataSvc.calculationData.input.others.tighteningSpecification;
            if (this.tighteningSpecification !== 'Informate Recommended') {
                this.tighteningSpecOverideDefault = this.dataSvc.calculationData.input.others.tighteningSpecificationInput;
            }

            if (this.dataSvc.calculationData.input.others.tighteningMethod == TighteningMethod.Torque)
                if (this.boltQuantityDefault !== undefined) {
                    setTimeout(() => {
                        this.emitDiagramEvent('Torque Sequence', null, this.boltQuantityDefault);
                    }, 1100);
                }


            this.boltMaterialAliasId=this.dataSvc.calculationData.input.recordId.boltMaterialAliasId;
            this.flangeMaterialAliasId1 = this.dataSvc.calculationData.input.recordId.flangeMaterialAliasId1;
            this.flangeMaterialAliasId2 = this.dataSvc.calculationData.input.recordId.flangeMaterialAliasId2;
            this.gasketAliasId=this.dataSvc.calculationData.input.recordId.gasketAliasId;        

        }
    }

    setPrestine() {
        this.customInputFormGroup.get('gasket').reset('', { emitEvent: false });
        this.doGasketReset = true;
    }

    emitDiagramEvent(diagramType: string, diagramId: string, noOfBolts: number = 0) {
        let diagramInfo = new DiagramInfo();
        diagramInfo.diagramId = diagramId;
        diagramInfo.diagramType = diagramType;
        diagramInfo.flangeTypeId = this.flangeTypeId;
        diagramInfo.flangeFacingTypeId = this.flangeFacingTypeId;
        diagramInfo.gasketTypeId = this.gasketTypeId;
        diagramInfo.noOfBolts = noOfBolts;
        this.diagram.emit(diagramInfo);
    }

    btnCustomInputConfirmClicked(): void {
        this.customInputFormGroup.markAllAsTouched();
        if (this.customInputFormGroup.valid) {
            this.customInputData.customStandardName = this.customInputFormGroup.get('customStandardName').value;
            this.customInputData.customPipeSizeName = this.customInputFormGroup.get('customPipeSize').value;
            this.customInputData.customPipeScheduleName = this.customInputFormGroup.get('customPipeSchedule').value;

            this.customInputData.flangeTypeId1 = this.customInputData.flangeTypeId2 = this.customInputFormGroup.get('flangeType').value;
            this.customInputData.flangeFacingTypeId = this.customInputFormGroup.get('flangeFacingType').value;
            this.customInputData.flangeMaterialId1 = this.customInputFormGroup.get('flangeMaterial').value;
            this.customInputData.gasketId = this.customInputFormGroup.get('gasket').value;
            this.customInputData.boltMaterialId = this.customInputFormGroup.get('boltMaterial').value;

            this.customInputData.boltType = this.customInputFormGroup.get('boltType').value;
            this.customInputData.tighteningSpecification = this.customInputFormGroup.get('tighteningSpecification').value;

            if (this.customInputData.tighteningSpecification != 'Informate Recommended') {
                this.customInputData.tighteningSpecificationInput = this.customInputFormGroup.get('tighteningSpecOveride').value;
            }
            if (this.customInputFormGroup.get('washer').value != 0) {
                this.customInputData.washerThickness = this.customInputFormGroup.get('washer').value;
            } else {
                delete this.customInputData.washerThickness;
            }

            if (this.customInputFormGroup.get('isAddnlOveride').value) {
                this.customInputData.additionalThickness = this.customInputFormGroup.get('addnlOverideValue').value;
            } else if (this.customInputFormGroup.get('addnlThickness').value === '0.00 mm') {
                this.customInputData.additionalThickness = this.customInputFormGroup.get('addnlThickness').value;
            } else {
                this.customInputData.additionalThicknessId = this.customInputFormGroup.get('addnlThickness').value;
            }
            this.customInputData.threadType = this.customInputFormGroup.get('threadType').value;
            this.customInputData.boltDimensionId = this.customInputFormGroup.get('boltSize').value;
            this.customInputData.boltQuantity = this.customInputFormGroup.get('boltQuantity').value;
            this.customInputData.nutDimensionId = this.customInputFormGroup.get('nutStandard').value;

            this.customInputData.isRedAreaBoltSelected = this.customInputFormGroup.get('isRedAreaBoltSelected').value;
            if (this.customInputFormGroup.get('isRedAreaBoltSelected').value == true) {
                this.customInputData.minimumBoltDiameter = this.customInputFormGroup.get('redAreaBolt').value;
            }

            this.customInputData.recommendedGasketStress = this.customInputFormGroup.get('isRecGasketStress').value
                ? this.customInputFormGroup.get('recGasketStress').value
                : null;
            this.customInputData.minimumGasketStress = this.customInputFormGroup.get('isMinGasketStress').value
                ? this.customInputFormGroup.get('minGasketStress').value
                : null;
            this.customInputData.maximumGasketStress = this.customInputFormGroup.get('isMaxGasketStress').value
                ? this.customInputFormGroup.get('maxGasketStress').value
                : null;
            this.customInputData.y = this.customInputFormGroup.get('isy').value ? this.customInputFormGroup.get('y').value : null;
            this.customInputData.m = this.customInputFormGroup.get('ism').value ? this.customInputFormGroup.get('m').value : null;
            this.customInputData.pAdditional = this.customInputFormGroup.get('ispAdditional').value ? this.customInputFormGroup.get('pAdditional').value : null;

            // later in the same method
            this.customInputData.boltMaterialAliasId = this.customInputFormGroup.get('boltMaterialAliasId')?.value;
            this.customInputData.flangeMaterialAliasId1 = this.customInputFormGroup.get('flangeMaterialAliasId1')?.value;
            this.customInputData.flangeMaterialAliasId2 = this.customInputFormGroup.get('flangeMaterialAliasId2')?.value;
            this.customInputData.gasketAliasId = this.customInputFormGroup.get('gasketAliasId')?.value;

            this.customInputData.isDataValid = true;
            this.returnData.emit(this.customInputData);
        } else {
            this.customInputData.isDataValid = false;
        }
    }

    get reduceInput(): AbstractControl {
        return this.customInputFormGroup.get('redAreaBolt');
    }

    onSelectedBoltType($event) {
        this.customInputFormGroup.get('redAreaBolt').setValue('', { emitEvent: false });
    }

    onSelectedBoltSize($event) {
        this.customInputFormGroup.get('redAreaBolt').setValue('', { emitEvent: false });
    }
}
